// let hostName = 'http://192.168.5.107:8080' // 本地
let hostName = 'https://zsy-dev.tsycvip.com' // 测试
// let hostName = 'http://192.168.5.109:8080' // 正式

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");
let apiServer = isLocalHost
  ? "http://localhost:5000/"
  : "https://cms.kzspp.com/";

export {
    hostName,
    apiServer,
}